import { Container, theme } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import type Employee from 'modules/employees/store/models/Employee'
import type PlanningVersion from 'modules/time_planning/store/models/PlanningVersion'

import Content from './Content'
import Navigator from './Navigator'

export interface Props {
  planningVersion: PlanningVersion
  employee: Employee
  contractVersions: ContractVersions
  canManageCompanySchedules: boolean
}

const IdReal = observer(
  ({ planningVersion, employee, contractVersions, canManageCompanySchedules }: Props) => {
    return (
      <>
        <div
          style={{
            marginBottom: theme.dimensions.bodyPadding,
          }}
        >
          <Navigator employee={employee} planningVersion={planningVersion} />
        </div>
        <Container fullWidth>
          <Content
            employee={employee}
            planningVersion={planningVersion}
            contractVersions={contractVersions}
            canManageCompanySchedules={canManageCompanySchedules}
          />
        </Container>
      </>
    )
  }
)

const Id = (props: Props) => <IdReal {...props} />

export default Id
